/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { createContext, PropsWithChildren } from 'react';
import { IPhoneActions } from '../use-phone-actions/types';
import { usePhoneActions } from '../use-phone';

export interface IPhoneWidgetContext {
  phoneActions: IPhoneActions
}

export const PhoneWidgetContext = createContext<IPhoneWidgetContext>(null!)

export default function PhoneWidgetProvider({ children }: PropsWithChildren<{}>) {
  return (
    <PhoneWidgetContext.Provider value={{
      phoneActions: usePhoneActions()
    }}>
      {children}
    </PhoneWidgetContext.Provider>
  )
}
